const Ajax = require('common/infra/ajax');

class API {
    getTags(projectId) {
        return Ajax.GET(`/api/projects/${projectId}/tags`);
    }

    createTag(projectId, tagId, tagJson) {
        return Ajax.POST(`/api/projects/${projectId}/tags/${tagId}`, tagJson);
    }

    updateTag(projectId, tagId, tagJson) {
        return Ajax.PUT(`/api/projects/${projectId}/tags/${tagId}`, tagJson);
    }

    deleteTag(projectId, tagId) {
        return Ajax.DELETE(`/api/projects/${projectId}/tags/${tagId}`);
    }

    getTagCategories(projectId) {
        return Ajax.GET(`/api/projects/${projectId}/tag-categories`);
    }

    createTagCategory(projectId, tagCategoryId, tagCategoryJson) {
        return Ajax.POST(`/api/projects/${projectId}/tag-categories/${tagCategoryId}`, tagCategoryJson);
    }

    updateTagCategory(projectId, tagCategoryId, tagCategoryJson) {
        return Ajax.PUT(`/api/projects/${projectId}/tag-categories/${tagCategoryId}`, tagCategoryJson);
    }

    deleteTagCategory(projectId, tagCategoryId) {
        return Ajax.DELETE(`/api/projects/${projectId}/tag-categories/${tagCategoryId}`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./system/infra/api/tag.js